import {
  getMainStoreInstance,
  clearRefinementHandler,
  getMainHelper,
  widgets,
} from '../../common/Algolia';
import {
  stripHTML,
} from '../../common/Utils';
import {
  triggerAlgoliaProductListFilterByEvent,
} from '../../common/Events';
import {
  getItemBrand,
  getItemCategory,
  getItemVariant,
  getItemClass,
  getItemListName,
} from '../../common/organism/product-thumbnails-module';

// Constants (ids)
const refinementBaseId = 'ais-refinement-list';
const refinementContainerId = 'ais-refinement-container';

// Constants (classes)
const refinementListElem = 'ais-refinement-list--item';
const refinementListElemLink = 'm-internal-search-filter-container__link';
const refinementListElemText = 'm-internal-search-filter-container__inline-txt';
const refinementListElemPrice = 'ais-range-slider--handle';
const refinementListElemClearAll = 'js-tags-clear';
const sliderHandle = 'ais-range-slider--handle';
const sliderTooltip = 'ais-range-slider--tooltip';

// Constants (attributes)
const dataSkuAttr = 'data-ocms-thumb-sku';

const facets = [
  'product_types',
  'concerns',
  'olfactive_notes',
  'textures',
  'collections',
];

/* Store instance */
let occStore;
let helper;
let dicoKeys;
let searchKeyword = '';
let disjunctiveFacetsRefinements;

/* DOM elements use as starting points */
const $refinementList = [];
const refinementWidgetList = [];

/* Element waiting for templates rendering (render event) */
let $aisRefinements;

let productsList = [];
let state;
let disjunctiveFacetsRefinementsArray = [];
let filterTypeValueArray = [];
let rawProducts;
let filterTypeValueString;
let filterSelectionValue;
let $elem;
let $eventTarget;
let price;
let priceMin;
let priceMax;


function getFilterSelectionValue(event) {
  $eventTarget = $(event.target);
  if ($eventTarget.is(`.${refinementListElem}`)) {
    filterSelectionValue = $eventTarget.find(`.${refinementListElemLink}`).attr('data-filter-id');
  } else if ($eventTarget.is(`.${refinementListElemText}`)) {
    filterSelectionValue = $eventTarget.closest(`.${refinementListElem}`).find(`.${refinementListElemLink}`).attr('data-filter-id');
  } else {
    priceMin = '';
    priceMax = '';
    priceMin = $(`.${sliderHandle}-lower`).find(`.${sliderTooltip}`).text();
    priceMax = $(`.${sliderHandle}-upper`).find(`.${sliderTooltip}`).text();
    filterSelectionValue = `${priceMin}-${priceMax}`;
  }
}

function refinementListEventSetup() {
  if (typeof occStore !== 'undefined') {
    occStore.once('render', () => {
      helper = getMainHelper(); // Helper doesn't exist before the store instance start() call
      helper.on('result', (results) => {
        // Clear refinements on empty response (e.g. to prevent UX problem due to collapsed refinement column)
        if (results.nbHits === 0) {
          helper.clearRefinements(clearRefinementHandler);
        }

        if ($eventTarget && filterSelectionValue !== '' && ($eventTarget.is(`.${refinementListElem}`) || $eventTarget.is(`.${refinementListElemText}`) || $eventTarget.is(`.${refinementListElemPrice}`)) && !$eventTarget.is(`.${refinementListElemClearAll}`)) {
          // Get the query
          searchKeyword = results.query;

          // Get the raw products data
          rawProducts = results.hits;

          // Empty arrays to avoid mismatched results
          disjunctiveFacetsRefinementsArray = [];
          filterTypeValueArray = [];
          productsList = [];

          // Save products data
          for (let i = 0, len = rawProducts.length; i < len; i += 1) {
            $elem = $(`li[${dataSkuAttr}="${rawProducts[i].sku}"]`);
            productsList.push({
              id: rawProducts[i].id,
              brand: getItemBrand($elem),
              price: rawProducts[i].price_f,
              name: rawProducts[i].title,
              variant: getItemVariant($elem),
              category: getItemCategory($elem),
              position: i + 1,
              productClass: getItemClass($elem),
              list: getItemListName($elem),
            });
          }

          // Strip all HTML in one hit
          productsList = JSON.parse(stripHTML(JSON.stringify(productsList)));

          // Retrieve the selected filters
          state = helper.getState();
          disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements;

          // Save the retrieved filters in disjunctiveFacetsRefinementsArray
          $.each(disjunctiveFacetsRefinements, (key, val) => {
            disjunctiveFacetsRefinementsArray.push({ types: key, values: val });
          });

          // Format and save type/values in filterTypeValueArray
          for (let j = 0, jLen = disjunctiveFacetsRefinementsArray.length; j < jLen; j += 1) {
            const tempValues = disjunctiveFacetsRefinementsArray[j].values;

            for (let k = 0, kLen = tempValues.length; k < kLen; k += 1) {
              filterTypeValueArray.push(`${disjunctiveFacetsRefinementsArray[j].types}:${tempValues[k]}`);
            }
          }

          // Retrieve Min and Max price
          priceMin = $(`.${sliderHandle}-lower`).find(`.${sliderTooltip}`).text();
          priceMax = $(`.${sliderHandle}-upper`).find(`.${sliderTooltip}`).text();

           // Add price range to filterTypeValueArray
          price = `price:${priceMin}-${priceMax}`;
          filterTypeValueArray.push(price);

          // Convert filterTypeValueArray to string with pipe separation
          filterTypeValueString = filterTypeValueArray.join(' | ');

          // Trigger event and pass data
          triggerAlgoliaProductListFilterByEvent(
            productsList,
            {
              filterSelection: filterSelectionValue,
              filters: filterTypeValueString,
              siteSearchKeyword: searchKeyword
            }
          );

          $eventTarget = '';
        }
      });
    });
  } else {
    console.error('Missing Algolia store connection.');
  }
}

/* Searchbox wideget setup */
function refinementListInit() {
  /* Init elements */
  $aisRefinements = $(`#${refinementContainerId}`);

  if ($aisRefinements.length > 0) {
    /* Get store instance */
    occStore = getMainStoreInstance();

    try {
      dicoKeys = OCMS.aisPanel.dicoKeys;
    } catch (error) {
      console.error('===== Missing dicoKeys for AIS-PANEL =====', error);
    }

    const tempConf = {
      operator: 'or',
      sortBy: ['name:asc', 'count:desc', 'isRefined'],
      showMore: false,
      cssClasses: {
        root: 'o-internal-search-filters__block o-internal-search-filters__block--bottom',
        item: 'm-internal-search-filter-container__item a-checkbox',
        active: 'a-checkbox--active',
      },
      collapsible: false,
    };

    /* Loop through facets and instanciate the associated widgets */
    for (let i = 0, len = facets.length; i < len; i += 1) {
      $refinementList.push($(`#${refinementBaseId}__${facets[i]}`)); // Build a list of jQuery object

      tempConf.container = $refinementList[$refinementList.length - 1][0]; // Get the last inserted DOM element as targetted container
      tempConf.attributeName = facets[i];
      tempConf.templates = {
        header: `<div class='m-internal-search-filter-container__title a-text-m a-text-m--bold' data-type='${facets[i]}'>${dicoKeys[facets[i]]}</div>`,
        item: (data) => {
          const label = data.label;
          const count = data.count;

          const refinemetListTpl = `<a class='m-internal-search-filter-container__link' data-filter-id='${label}' data-btn-id='${label}'> <span class='a-text-m m-internal-search-filter-container__inline-txt'>${label}</span> <span class='a-text-m m-internal-search-filter-container__inline-txt'>(${count})</span> </a>`;

          return refinemetListTpl;
        }
      };

      /* Create and store refinement widget */
      refinementWidgetList.push(widgets.refinementList(tempConf));
      occStore.addWidget(refinementWidgetList[refinementWidgetList.length - 1]);
    }

    $(document).ready(() => {
      $(`#${refinementContainerId}`)[0].addEventListener('click', getFilterSelectionValue, true);
    });

    /* Setup widget events after the "render" completion */
    refinementListEventSetup();

    return true;
  }

  return false;
}

// Named exports
export default refinementListInit;



// WEBPACK FOOTER //
// ./js/desktop/molecule/algolia-refinement-list.js